// "Mensaje principal" / "Versión en inglés" en los editores del mensaje del kit
// (Prospecto y Referido, y Renovaciones). Josef, 2026-10-27: *"el kit de
// Medicare Advantage no sale en inglés a la persona que habla inglés"*.
//
// La regla vive en crm-app/kitPorContexto.js: a un cliente cuyo idioma es
// inglés le sale la versión en inglés si existe; si no, el principal. A los
// demás, siempre el principal. Esto es solo el botón y la explicación.
export function SelectorDeIdiomaDelKit({ idioma, onChange, tieneIngles, lang }) {
  const es = lang === 'es';
  const opciones = [
    { id: 'es', label: es ? 'Mensaje principal' : 'Main message' },
    { id: 'en', label: `🇺🇸 ${es ? 'Versión en inglés' : 'English version'}${tieneIngles ? ' ✓' : ''}` },
  ];
  return (
    <div>
      <div style={{ display: 'flex', gap: '.4rem', flexWrap: 'wrap' }}>
        {opciones.map((o) => (
          <button key={o.id} type="button" onClick={() => onChange(o.id)}
            aria-pressed={idioma === o.id}
            style={{
              padding: '.35rem .75rem', borderRadius: 8, fontSize: '.78rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
              border: `1px solid ${idioma === o.id ? 'rgba(0,212,255,.45)' : 'var(--c-border,#1a3550)'}`,
              background: idioma === o.id ? 'var(--c-cyan-dim,rgba(0,212,255,.12))' : 'transparent',
              color: idioma === o.id ? 'var(--c-cyan,#00d4ff)' : 'var(--c-text3,#45688a)',
            }}>
            {o.label}
          </button>
        ))}
      </div>
      <div style={{ fontSize: '.7rem', color: 'var(--c-text3,#45688a)', marginTop: '.3rem' }}>
        {idioma === 'en'
          ? (es
            ? 'Este texto le sale a los clientes cuyo idioma es inglés. Si lo dejas vacío, a ellos les sale el mensaje principal.'
            : 'This text goes to clients whose language is English. If you leave it empty, they get the main message.')
          : (es
            ? 'Le sale a todos los clientes, salvo a los de idioma inglés cuando hay versión en inglés.'
            : 'Goes to every client, except English-speaking ones when there is an English version.')}
      </div>
    </div>
  );
}
